import {
  Aws_Partner,
  C1,
  C3,
  C4,
  DataBricks,
  Goldman_Sachs_Logo,
  IOA,
  LSE_logo,
  Marketreach_logo,
  Ngx_Logo,
  P2,
  P3,
  P5,
  P6,
  SpeedData_Logo,
} from "../../assets";
import { Link } from "react-router-dom";
import { useRef } from "react";
import { useMarqueeLoop } from "../../utils/animations";

export default function Partners() {
  const marqueeRef = useRef(null);
  useMarqueeLoop(marqueeRef, { speed: 0.7 });

  return (
    <div className="sliders" ref={marqueeRef}>
      <div className="second-slider">
        <div className="images-host">
          <div className="images">
            <div className="scroll-img">
              <img src={P2} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={P3} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={P5} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img
                src={Aws_Partner}
                alt="Company logo"
                style={{ height: "30px", objectFit: "contain" }}
              />
            </div>
            <div className="scroll-img">
              <img src={P6} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={DataBricks} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={IOA} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <Link to="/speedata" aria-label="Speedata partner page">
                <img src={SpeedData_Logo} alt="Company logo" />
              </Link>
            </div>
          </div>
          <div className="images">
            <div className="scroll-img">
              <img src={P2} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={P3} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={P5} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img
                src={Aws_Partner}
                alt="Company logo"
                style={{ height: "30px", objectFit: "contain" }}
              />
            </div>
            <div className="scroll-img">
              <img src={P6} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={DataBricks} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={IOA} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <Link to="/speedata" aria-label="Speedata partner page">
                <img src={SpeedData_Logo} alt="Company logo" />
              </Link>
            </div>
          </div>
          <div className="images">
            <div className="scroll-img">
              <img src={P2} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={P3} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={P5} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img
                src={Aws_Partner}
                alt="Company logo"
                style={{ height: "30px", objectFit: "contain" }}
              />
            </div>
            <div className="scroll-img">
              <img src={P6} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={DataBricks} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={IOA} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <Link to="/speedata" aria-label="Speedata partner page">
                <img src={SpeedData_Logo} alt="Company logo" />
              </Link>
            </div>
          </div>
          <div className="images">
            <div className="scroll-img">
              <img src={P2} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={P3} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={P5} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img
                src={Aws_Partner}
                alt="Company logo"
                style={{ height: "30px", objectFit: "contain" }}
              />
            </div>
            <div className="scroll-img">
              <img src={P6} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={DataBricks} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={IOA} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <Link to="/speedata" aria-label="Speedata partner page">
                <img src={SpeedData_Logo} alt="Company logo" />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <style jsx="true">{`
        .worldwide-flex {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
        }
        .worldwide-flex .join {
          flex-basis: 500px;
          margin-bottom: 2rem;
        }
        .worldwide-flex .join h3 {
          line-height: 1.5;
          font-size: 1.5rem;
        }
        .join a {
          text-decoration: none;
          color: inherit;
        }
        .join .btn-white {
          padding-top: 1rem;
          padding-bottom: 1rem;
          font-size: 1.3rem;
        }
        .worldwide-flex .img {
          flex-basis: 500px;
        }
        .started {
          text-decoration: none;
          color: inherit;
          display: flex;
          justify-content: center;
          margin: 1rem auto;
        }
        .started .btn-white {
          padding: 1rem 4rem;
          font-size: 1.2rem;
        }
        .container h3 {
          margin-bottom: 1rem;
        }
        .worldwide {
          background-color: #1f3569;
          padding-top: 5rem;
          padding-bottom: 5rem;
        }
        .second-slider {
          padding-top: 2rem;
          padding-bottom: 2rem;
        }

        .images-host {
          display: flex;
          flex-direction: row;
          overflow: hidden;
        }
        .sliders .images {
          display: grid;
          grid-template-columns: repeat(auto-fit, 170px);
          grid-gap: 2rem;
          grid-auto-rows: minmax(170px, auto);
          padding-top: 3rem;
          padding-bottom: 3rem;
          justify-content: center;
        }

        .scroll .scroll-img {
          background-color: #fff;
          color: #1f3569;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
          padding: 1rem;
        }
        .scroll .scroll-img p {
          font-weight: 600;
          font-size: 0.8rem;
          margin-top: 1rem;
        }
        .news {
          color: #1f3569;
        }

        .second-slider .images {
          display: flex;
          justify-content: space-between;
          padding-left: 1rem;
          padding-right: 1rem;
          flex-direction: row;
          padding-bottom: 1rem;
          padding-top: 1rem;
        }

        .second-slider .scroll-img {
          // cursor: pointer;
          color: #1f3569;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 1rem;
        }
        .second-slider .scroll-img img {
          min-width: 120px;
          object-fit: cover;
        }
        .second-slider .scroll-img img.royal {
          min-width: 150px;
        }
      `}</style>
    </div>
  );
}

export function Clients() {
  const marqueeRef = useRef(null);
  useMarqueeLoop(marqueeRef, { speed: 0.8 });

  return (
    <div className="sliders m-0 space-y-0" ref={marqueeRef}>
      <div className="second-slider">
        <div className="images-host">
          <div className="images">
            <div className="scroll-img">
              <img src={C1} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={C3} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={C4} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={LSE_logo} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={Marketreach_logo} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={Goldman_Sachs_Logo} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={Ngx_Logo} alt="Company logo" />
            </div>
          </div>
          <div className="images">
            <div className="scroll-img">
              <img src={C1} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={C3} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={C4} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={LSE_logo} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={Marketreach_logo} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={Goldman_Sachs_Logo} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={Ngx_Logo} alt="Company logo" />
            </div>
          </div>
          <div className="images">
            <div className="scroll-img">
              <img src={C1} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={C3} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={C4} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={LSE_logo} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={Marketreach_logo} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={Goldman_Sachs_Logo} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={Ngx_Logo} alt="Company logo" />
            </div>
          </div>
          <div className="images">
            <div className="scroll-img">
              <img src={C1} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={C3} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={C4} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={LSE_logo} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={Marketreach_logo} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={Goldman_Sachs_Logo} alt="Company logo" />
            </div>
            <div className="scroll-img">
              <img src={Ngx_Logo} alt="Company logo" />
            </div>
          </div>
        </div>
      </div>
      <style jsx="true">{`
        .worldwide-flex {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
        }
        .worldwide-flex .join {
          flex-basis: 500px;
          margin-bottom: 2rem;
        }
        .worldwide-flex .join h3 {
          line-height: 1.5;
          font-size: 1.5rem;
        }
        .join a {
          text-decoration: none;
          color: inherit;
        }
        .join .btn-white {
          padding-top: 1rem;
          padding-bottom: 1rem;
          font-size: 1.3rem;
        }
        .worldwide-flex .img {
          flex-basis: 500px;
        }
        .started {
          text-decoration: none;
          color: inherit;
          display: flex;
          justify-content: center;
          margin: 1rem auto;
        }
        .started .btn-white {
          padding: 1rem 4rem;
          font-size: 1.2rem;
        }
        .container h3 {
          margin-bottom: 1rem;
        }
        .worldwide {
          background-color: #1f3569;
          padding-top: 5rem;
          padding-bottom: 5rem;
        }
        .second-slider {
          padding-top: 0rem;
          padding-bottom: 0rem;
        }

        .images-host {
          display: flex;
          flex-direction: row;
          overflow: hidden;
        }
        .sliders .images {
          display: grid;
          grid-template-columns: repeat(auto-fit, 170px);
          grid-gap: 2rem;
          grid-auto-rows: minmax(170px, auto);
          padding-top: 0rem !important;
          padding-bottom: 0rem !important;
          justify-content: center;
        }

        .scroll .scroll-img {
          background-color: #fff;
          color: #1f3569;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
          padding: 1rem;
        }
        .scroll .scroll-img p {
          font-weight: 600;
          font-size: 0.8rem;
          margin-top: 1rem;
        }
        .news {
          color: #1f3569;
        }

        .second-slider .images {
          display: flex;
          justify-content: space-between;
          padding-left: 1rem;
          padding-right: 1rem;
          flex-direction: row;
          padding-bottom: 1rem;
          padding-top: 1rem;
        }

        .second-slider .scroll-img {
          // cursor: pointer;
          color: #1f3569;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 1rem;
        }
        .second-slider .scroll-img img {
          min-width: 120px;
          object-fit: cover;
        }
        .second-slider .scroll-img img.royal {
          min-width: 150px;
        }
      `}</style>
    </div>
  );
}
